exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.table[data-v-1bb63ccf] {\n  padding: 20px;\n}\ntable > tr > th[data-v-1bb63ccf] {\n  margin: 20px;\n}\n.box-header[data-v-1bb63ccf] {\n  background-image: linear-gradient(\n    to right,\n    rgba(38, 153, 251),\n    rgba(146, 205, 255)\n  );\n}\n.dropdown-toggle[data-v-1bb63ccf] {\n  background-color: rgba(255, 132, 78);\n}\n.tablinks[data-v-1bb63ccf] {\n  background-image: linear-gradient(\n    to right,\n    rgba(38, 153, 251),\n    rgba(146, 205, 255)\n  );\n}\nth[data-v-1bb63ccf] {\n  padding-left: 20px;\n}\n.trip-detail-tbl td[data-v-1bb63ccf],\nth[data-v-1bb63ccf] {\n  padding: 4px 15px !important;\n}\n/deep/ .tripModal .v--modal-box[data-v-1bb63ccf] {\n  min-height: 500px !important;\n  max-height: 500px !important;\n  height: 500px !important;\n  overflow-y: scroll !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1bb63ccf","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/trip/TripActivity.vue
// module id = 136
// module chunks = 0